var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('p',{style:({ fontSize: _vm.labelSize })},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"text-primary font-semibold",style:({ fontSize: _vm.valueSize })},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }